import { useEffect } from "react";

export const useKioskProtection = ({ enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) return;

    const preventContextMenu = (e) => {
      e.preventDefault();
    };

    const preventDragStart = (e) => {
      e.preventDefault();
    };

    const preventSelectStart = (e) => {
      e.preventDefault();
    };

    const preventKeyDown = (e) => {
      const key = e.key?.toLowerCase();

      // 새로고침
      if (e.key === "F5" || (e.ctrlKey && key === "r")) {
        e.preventDefault();
        return;
      }

      // 개발자도구
      // if (
      //   e.key === "F12" ||
      //   (e.ctrlKey && e.shiftKey && ["i", "j", "c"].includes(key)) ||
      //   (e.ctrlKey && key === "u")
      // ) {
      //   e.preventDefault();
      //   return;
      // }

      // 뒤로가기 방지용 백스페이스 (input 제외)
      const tag = e.target?.tagName?.toLowerCase();
      const isEditable =
        tag === "input" ||
        tag === "textarea" ||
        e.target?.isContentEditable;

      if (e.key === "Backspace" && !isEditable) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", preventContextMenu);
    document.addEventListener("dragstart", preventDragStart);
    document.addEventListener("selectstart", preventSelectStart);
    document.addEventListener("keydown", preventKeyDown);

    return () => {
      document.removeEventListener("contextmenu", preventContextMenu);
      document.removeEventListener("dragstart", preventDragStart);
      document.removeEventListener("selectstart", preventSelectStart);
      document.removeEventListener("keydown", preventKeyDown);
    };
  }, [enabled]);
};